export const CONTEXT_ENUM = {
    SUBCATEGORY: 'CONTEXT_SUBCATEGORY',
    SEARCH: 'CONTEXT_SEARCH',
    UNSPECIFIED: 'CONTEXT_UNSPECIFIED',
};
